import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   getSingleContractorMasterApiCall,
   handleContractorMasterApiCall,
   handleContractorMasterEditApiCall,
   handlesingleContractorcontactsdetailsAddApiCall,
   handlesingleContractorcontactsdetailsEditApiCall,
} from "../../Api/api";

// initial state
const initialState = {
   dataList: [],
   singleContractorMaster: {},
   isLoading: false,
   isError: false,
   isSuccess: false,
};

// Fetch single contractorMaster
export const fetchSingleContractorMasterAsync = createAsyncThunk(
   "contractorMaster/singleContractorMaster",
   async ({ id, done, err }, thunkAPI) => {
      try {
         const { data: response } = await getSingleContractorMasterApiCall(id);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Edit contractor master
export const editContractorMasterAsync = createAsyncThunk(
   "contractorMaster/editContractorMaster",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await handleContractorMasterEditApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Add contractor master
export const addContractorMasterAsync = createAsyncThunk(
   "contractorMaster/addContractorMaster",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const { data: response } = await handleContractorMasterApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

//Edit Contact details
export const editContactDetailsAsync = createAsyncThunk(
   "auth/contractor/contacts/edit",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } =
            await handlesingleContractorcontactsdetailsEditApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

//Add Contact details
export const addContactDetails = createAsyncThunk(
   "auth/contractor/contacts/add",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await handlesingleContractorcontactsdetailsAddApiCall(
            data
         );

         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

const contractorMasterSlice = createSlice({
   name: "contractorMaster",
   initialState,

   reducers: {
      clearState: (state, action) => {
         state.dataList = [];
         state.singleContractorMaster = null;
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      // single Vendor master
      builder.addCase(fetchSingleContractorMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchSingleContractorMasterAsync.fulfilled, (state, action) => {
         state.singleContractorMaster = action.payload;
         state.isLoading = false;
      });
      builder.addCase(fetchSingleContractorMasterAsync.rejected, (state, action) => {
         state.isError = action.payload;
         state.isLoading = false;
      });
   },
});

//const { clearState } = contractorMasterSlice.actions;
const contractorMasterReducer = contractorMasterSlice.reducer;
export default contractorMasterReducer;
